// seller-how-it-works.tsx
import { UserPlus, FileEdit, ShieldCheck, Gavel, Banknote, CheckCircle } from 'lucide-react'

const getFallbackIcon = (title = '', index) => {
  const lower = title.toLowerCase()
  if (lower.includes('register') || index === 0) return UserPlus
  if (lower.includes('list') || lower.includes('upload') || index === 1) return FileEdit
  if (lower.includes('secure') || lower.includes('verify') || index === 2) return ShieldCheck
  if (lower.includes('auction') || lower.includes('bid') || index === 3) return Gavel
  if (lower.includes('get') || lower.includes('paid') || index === 4) return Banknote
  return CheckCircle
}

export function SellerHowItWorks({ header, steps }) {
  const finalHeader = header || { title: { value: 'How It Works' }, description: { value: '' } }
  const finalSteps = steps.length > 0 ? steps : []

  return (
    <section className="bg-primary-dark/30 py-16 lg:py-24 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16 lg:mb-20">
          <h2 className="text-4xl lg:text-5xl font-extrabold text-white tracking-tight uppercase">
            {finalHeader?.title?.value || 'Seller Process'}
          </h2>
          {finalHeader?.description?.value && (
            <p className="mt-4 text-description text-lg max-w-3xl mx-auto leading-relaxed">
              {finalHeader.description.value.replace(/<[^>]+>/g, '')} {/* strip HTML tags */}
            </p>
          )}
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Horizontal line on desktop */}
          <div className="hidden lg:block absolute top-[68px] left-0 right-0 h-px bg-white/10 z-0" />

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-6 relative z-10">
            {finalSteps.map((step, idx) => {
              const Icon = getFallbackIcon(step.title?.value || '', idx)
              const hasIcon = step.icon?.value?.trim()

              return (
                <div key={idx} className="flex flex-col items-center text-center group">
                  {/* Icon Circle */}
                  <div className="w-20 h-20 rounded-2xl bg-[#1e293b] border border-primary flex items-center justify-center mb-8 shadow-lg shadow-blue-900/10 transition-all group-hover:border-blue-500/50 group-hover:scale-105">
                    {hasIcon ? (
                      <img
                        src={step.icon.value}
                        alt=""
                        className="w-10 h-10 object-contain"
                        onError={(e) => (e.currentTarget.style.display = 'none')}
                      />
                    ) : (
                      <Icon className="w-10 h-10 text-primary" strokeWidth={1.5} />
                    )}
                  </div>

                  {/* Title & Description */}
                  <h3 className="text-white font-bold text-xl mb-3">
                    {step.title?.value || `Step ${idx + 1}`}
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed px-4 max-w-xs">
                    {step.description?.value?.replace(/<[^>]+>/g, '') || ''}
                  </p>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </section>
  )
}